// Seed data: site-wide content (hero, about, leadership, contact, settings).
// Mirrors the `site_settings` and `home_sections` tables in Supabase.

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_bombay-sabha/artifacts/z77ljcgs_bcsabha-logo.png";

export const seedSiteSettings = {
  org_name: "The Bombay Catholic Sabha",
  motto: "Love · Service · Fraternity",
  tagline: "A recognised laity organisation of the Archdiocese of Bombay",
  contact_emails: ["office@bcsabha.org", "", ""],
  contact_phone: "+91 22 2640 1234",
  whatsapp: "+91 98200 12345",
  address:
    "The Bombay Catholic Sabha, Archdiocese of Bombay, c/o St. Michael's Church, Mahim, Mumbai 400 016. Affiliated to the All India Catholic Union.",
  office_hours: "Mon – Fri, 10:00 AM – 6:00 PM",
  facebook: "https://facebook.com/bcsabha",
  instagram: "https://instagram.com/bcsabha",
  youtube: "https://youtube.com/@bcsabha",
  agm_pdf_url:
    "https://pub-c0208a4578ba4aeb9e729da4dfc2d05c.r2.dev/pdfs/1.THE%20BCS%2001%20final%20draft%2029%2008%2026.pdf",
  annual_accounts_pdf_url:
    "https://pub-c0208a4578ba4aeb9e729da4dfc2d05c.r2.dev/pdfs/ANNUAL%20ACCOUNTS%202025%202026%20DD.pdf",
};

export const seedHomeSections = {
  hero: {
    eyebrow: "Archdiocese of Bombay · Laity Organisation",
    title_line1: "Serving Mumbai's Catholic community",
    title_accent: "with faith, action and purpose.",
    body:
      "The Bombay Catholic Sabha is a recognised laity organisation of the Archdiocese of Bombay, with more than 66,000 life members. We work across every deanery in the Archdiocese through our units and forums — in civic life, the environment, and the formation of young leaders.",
    image_url:
      "https://images.unsplash.com/photo-1473177104440-ffee2f376098?auto=format&fit=crop&w=1200&q=75",
  },
  mission: {
    eyebrow: "What We Do",
    title: "Three forums, one mission across the Archdiocese",
    body:
      "Based in Mumbai, we operate in every deanery of the Archdiocese of Bombay through dedicated forums that serve civic life, the environment, and the next generation of leaders.",
  },
  legal_aid: {
    title: "Legal aid for the marginalized",
    body:
      "In collaboration with DSLA (District Legal Services Authority), retired judges provide free legal advice to marginalized members of our society.",
  },
  cta: {
    title: "Be part of the Sabha's mission",
    body:
      "Join 66,000+ members serving Mumbai with love, service and fraternity — as a member, a volunteer or a supporter.",
  },
};

export const seedAboutContent = {
  hero: {
    eyebrow: "Our story",
    title: "Empowering change",
    subtitle: "37+ years of service and empowerment",
    intro:
      "The Bombay Catholic Sabha is a vital part of the Catholic community in Mumbai—building faith and civic responsibility through parish units, advocacy and social programmes that empower the laity and promote Christian values in public life.",
    stats: [
      { label: "Life members", value: "67,689+" },
      { label: "Years of service", value: "37+" },
      { label: "Deaneries", value: "9" },
    ],
  },
  vision: {
    eyebrow: "Our vision",
    quote:
      "Create a Just Society through Involvement in Socio, Civic and Political Affairs",
  },
  founded: {
    title: "Founded in Mumbai, rooted in the Archdiocese",
    body:
      "The Bombay Catholic Sabha was founded on 20 January 1989 under the patronage of Archbishop Cardinal Simon Pimenta. We salute our founder members and all who worked tirelessly to establish the organisation.",
    membership:
      "Membership today stands at 67,689 and growing. The Sabha is the largest lay organisation in the Archdiocese of Bombay—and in India—affiliated to the All India Catholic Union. Our patron is the Archbishop of Bombay, Archbishop John Rodrigues.",
    founder_members: [
      "Mr. Raphael Donald",
      "Mr. Faust Castellino",
      "Dr. Louis D'Silva",
      "Mr. George Menezes",
      "Dr. Allan Saldanha",
    ],
    founder_note: "…and several others who helped build the Sabha from the ground up.",
    founder_members_heading: "Founder members",
    registration:
      "Registered as a Public Trust under The Mumbai Public Trusts Act, 1950. Regn. No. 12545 (BOM)",
  },
  milestones: [
    {
      period: "1989",
      title: "Foundation",
      body:
        "Founded on 20 January under the patronage of Archbishop Cardinal Simon Pimenta. Registered as a Public Trust under the Mumbai Public Trusts Act, 1950. Regn. No. 12545 (BOM)",
    },
    {
      period: "1990s–2000s",
      title: "Building the movement",
      body:
        "Past Secretary Mr. Lavy D'Costa promoted new parish units and community activity. Under Prof. Lila's leadership, the Annual Academic Awards began—a prestigious tradition that continues every year.",
    },
    {
      period: "2005",
      title: "Sabha Day & renewed focus",
      body:
        "Under President Mr. Dolphy D'Souza, the Sabha broadened civic, political, social action and youth work. Sabha Day was conceptualised as an annual fundraiser—the first held at St. Joseph Wadala West Grounds, with the Sabha Anthem composed by Marcia D'Cunha.",
    },
    {
      period: "2005–2009",
      title: "Public rallies",
      body:
        "Large rallies at Azad Maidan and, in 2009, Shivaji Park—where over 90,000 people of all faiths gathered with like-minded groups to protest injustice against the community.",
    },
    {
      period: "2014+",
      title: "Honouring our guides",
      body:
        "During Mr. Gordon D'Souza's presidency, unit awards moved to a deanery-wise model. Memorial awards were established in honour of spiritual advisors Late Fr. Salvador Rodrigues and Late Fr. Edward D'Souza.",
    },
    {
      period: "2015+",
      title: "Civil services & civic duty",
      body:
        "Civil services promotion was scaled up under Mr. Gordon D'Souza and advanced by President Mrs. Rita D'Sa. The Sabha intensified voter registration, list verification, and pre-election Meet Your Candidate programmes.",
    },
  ],
  programmes: [
    {
      title: "Sabha Day",
      body:
        "Held every year since 2005—our flagship gathering and fundraiser, born from the need to sustain growing parish and city-wide operations.",
    },
    {
      title: "Academic Awards",
      body:
        "An annual celebration of student achievement, rooted in the legacy of Prof. Lila and the unit-building era of the late 1990s.",
    },
    {
      title: "Election awareness",
      body:
        "National, state and local elections taken seriously—45+ awareness camps across parishes last year, plus Meet Your Candidate events before each poll.",
    },
    {
      title: "BCS Footcom",
      body:
        "Youth football since 2004—the first league tournament at Don Bosco Matunga, with finals at St. Xavier's. The Youth Forum carries this legacy forward.",
    },
    {
      title: "Environment",
      body:
        "Seminars on waste management, plastic collection and tree plantation. Post-COVID, a drive to plant over one lakh trees across Mumbai and surrounding areas.",
    },
    {
      title: "Advocacy",
      body:
        "Units and members are encouraged to engage on injustice, civic issues and political participation—faith lived in public life.",
    },
  ],
  gratitude: {
    eyebrow: "With gratitude",
    title: "Standing together across the Archdiocese",
    body:
      "We thank our supporters, sponsors, unit members, collaborating NGOs, and especially our office staff for their wonderful support—always with a smile. Special thanks to the Archdiocese bishops and parish priests for standing behind our initiatives.",
    closing:
      "The Sabha encourages every unit and member to engage with injustice, elections, and civic and political life—because faith and responsibility belong together in the city we serve.",
  },
  milestones_section: {
    eyebrow: "Milestones",
    title: "A journey of parish units, public witness and growing impact",
  },
  programmes_section: {
    eyebrow: "Today's work",
    title: "Programmes that carry our history forward",
  },
  leadership_section: {
    eyebrow: "Leadership",
    title: "Current office bearers",
    subtitle:
      "The elected leadership guiding The Bombay Catholic Sabha across parishes, deaneries and forums throughout the Archdiocese of Bombay.",
  },
  former_presidents_section: {
    eyebrow: "Our history",
    title: "Former Presidents",
    subtitle:
      "Leaders who have guided the Sabha through decades of parish units, civic witness and community service.",
  },
  former_presidents: [
    { period: "1990 – 1992", name: "Mr. Raphael Donald", parish: "St. Peter's, Bandra" },
    { period: "1992 – 1994", name: "Mr. Raphael Donald", parish: "St. Peter's, Bandra" },
    { period: "1994 – 1996", name: "Dr. Allan Saldanha", parish: "Our Lady of Victories, Mahim" },
    { period: "1996 – 1998", name: "Dr. Allan Saldanha", parish: "Our Lady of Victories, Mahim" },
    { period: "1998 – 1999", name: "Dr. Louis D'Silva", parish: "Mount Carmel, Bandra" },
    { period: "1999 – 2001", name: "Mr. Faust Castellino", parish: "St. Michael, Mahim" },
    { period: "2001 – 2002", name: "Mr. Raphael Donald", parish: "St. Peter's, Bandra" },
    { period: "2002 – 2004", name: "Mr. Raphael Donald", parish: "St. Peter's, Bandra" },
    { period: "2004 – 2007", name: "Mr. Dolphy D'Souza", parish: "Our Lady of Lourdes, Orlem" },
    { period: "2007 – 2010", name: "Mr. Dolphy D'Souza", parish: "Our Lady of Lourdes, Orlem" },
    { period: "2010 – 2013", name: "Mr. Gordon D'Souza", parish: "St. Francis Xavier, Vile Parle" },
    { period: "2013 – 2016", name: "Mr. Gordon D'Souza", parish: "St. Francis Xavier, Vile Parle" },
    { period: "2016 – 2019", name: "Mrs. Rita D'Sa", parish: "St. Michael, Mahim" },
    { period: "2019 – 2022", name: "Adv. Raphael D'Souza", parish: "St. John Bosco, Borivili" },
  ],
  cta: {
    title: "Come be a member of the Sabha",
    subtitle: "Feel proud. Feel committed. Feel proudly Indian.",
    motto: "Committed to create a better tomorrow, today!",
  },
  leadership: [
    { name: "Norbert Mendonca", role: "President", note: "O.L.OF LOURDES - ORLEM", image_url: "" },
    { name: "Alex DSouza", role: "Vice President", note: "O.L.OF ROSARY - GOREGAON", image_url: "" },
    { name: "Kevin DSouza", role: "Vice President", note: "ST. JUDE - JERI MERI", image_url: "" },
    { name: "Francis Colaco", role: "Secretary General", note: "O.L.OF GOOD COUNSEL - SION", image_url: "" },
    { name: "CA. Ajoy Fernandes", role: "Treasurer", note: "O.L.OF VICTORIES - MAHIM", image_url: "" },
    { name: "Adv. Elton George", role: "Legal Advisor", note: "O.L.OF LOURDES - ORELM", image_url: "" },
  ],
};
